import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import './addUsers.css';
import {
  addEployerUser,
  forgotPassword,
  updateEployerUser,
} from './endpoints/action';
import { addUserSelector } from './endpoints/selector';
import { setInitialState } from './endpoints/slice';
import ResetModal from './Modal/resetPasswordModal';
import { useNavigate } from 'react-router-dom';

export default (props) => {
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');

  const userDetails = props.userDetails;
  const locationDropdownList = props.locationDropdownList;
  const userTypesList = props.userTypesList;
  const editUser = props.editUser;
  const addContact = props.addContacts;
  const location = props.location;

  const navigate = useNavigate();
  const { resetSuccess, resetError, saveButtonDisabled } = useSelector(addUserSelector);
  const [locationName, setLocationName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [userType, setUserType] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [cellNumber, setCellNumber] = useState('');
  const [workNumber, setWorkNumber] = useState('');
  const [empUserId, setEmpUserId] = useState('');
  const [approvalUser, setApprovalUser] = useState(false);
  const [contactUser, setContactUser] = useState(false);
  const [errors, setErrors] = useState([]);
  const [showReset, setShowReset] = useState(false);
  const { successMessage, errorMessage } = useSelector(addUserSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userDetails.length > 0) {
      userDetails.map((user) => {
        setLocationName(user.locationId);
        setFirstName(user.firstName);
        setLastName(user.lastName);
        setEmail(user.email);
        setPassword(user.password);
        setUserType(user.userType);
        setCellNumber(user.cellPhoneNumber);
        setWorkNumber(user.workNumber);
        setEmployeeId(user.employeeId);
        setEmpUserId(user.employerUserId);
        setApprovalUser(user.isApprovalUser);
        setContactUser(user.isContact);
      });
    } else {
      setLocationName('');
      setFirstName('');
      setLastName('');
      setEmail('');
      setPassword('');
      setUserType('');
      setCellNumber('');
      setWorkNumber('');
      setEmployeeId('');
      setEmpUserId('');
      setApprovalUser(false);
      setContactUser(false);
    }
  }, [userDetails]);

  useEffect(() => {
    if (location && location.length > 0) {
      setLocationName(location[0].id);
    }
  }, [location]);

  useEffect(() => {
    if (successMessage == 'EmployerUser details added successfully') {
      setLocationName('');
      setFirstName('');
      setLastName('');
      setEmail('');
      setPassword('');
      setUserType('');
      setCellNumber('');
      setWorkNumber('');
      setEmployeeId('');
      setEmpUserId('');
      setConfirmPassword('');
      setApprovalUser(false);
      setContactUser(false);
    }
  }, [successMessage]);

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  };

  const validateEmpID = (key, value) => {
    value = ChkEmploeeID(value);
    if (key === 'employeeId') setEmployeeId(value);
    else {
      setEmployeeId(value);
    }
  };

  const ChkEmploeeID = (value) => {
    if (!value) return value;
    const ChkEmploeeValue = value;
    const ChkEmploeeValueLength = ChkEmploeeValue.length;
    if (ChkEmploeeValueLength <= 10) {
      return ChkEmploeeValue;
    } else {
      return `${ChkEmploeeValue.slice(0, 10)}`;
    }
  };

  const validatePhoneNumber = (key, value) => {
    value = formatPhoneNumber(value);
    if (key == 'cellNumber') setCellNumber(value);
    else {
      setWorkNumber(value);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const phoneno = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
    const passwordPattern =
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})';
    const emailPattern = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$';
    if (!locationName || locationName === '')
      newErrors.locationName = 'Please enter the Location Name';
    if (!firstName || firstName === '')
      newErrors.firstName = 'Please enter the First Name';
    if (!lastName || lastName === '')
      newErrors.lastName = 'Please enter the Last Name';
    if (!email || email === '') newErrors.email = 'Please enter the Email';
    if (!userType || userType === '')
      newErrors.userType = 'Please enter the User Type';
    if (!cellNumber || cellNumber === '') {
      newErrors.cellNumber = 'Please enter the Phone number';
    } else if (!cellNumber.match(phoneno)) {
      newErrors.cellNumber = 'Phone number should be a 10 digit number';
    }
    if (!workNumber || workNumber === '') {
      newErrors.workNumber = 'Please enter the Phone number';
    } else if (!workNumber.match(phoneno)) {
      newErrors.workNumber = 'Phone number should be a 10 digit number';
    }
    if (email !== '') {
      if (!email.match(emailPattern)) {
        newErrors.email = 'Invalid Email format';
      }
    }
    if (!editUser) {
      if (!password || password === '')
        newErrors.password = 'Please enter the Password';
      if (!password.match(passwordPattern)) {
        newErrors.password =
          'Password must have 8 characters including 1 uppercase, 1 numeric and 1 special character';
      }
      if (!confirmPassword || confirmPassword === '') {
        newErrors.confirmPassword = 'Please enter the Confirm Password';
      } else if (password !== confirmPassword) {
        newErrors.confirmPassword =
          'Password and Confirm Password must be same';
      }
    }

    return newErrors;
  };

  const validateAndSubmit = (e) => {
    e.preventDefault();

    const body = document.querySelector('#root');

    body.scrollIntoView(
      {
        behavior: 'smooth',
      },
      500
    );

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      setErrors([]);
      if (editUser === true || addContact === false) {
        dispatch(
          updateEployerUser(config.baseUrl, {
            employerUserId: empUserId || 0,
            employerId: login.employerId,
            userType: userType,
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: '',
            cellPhoneNumber: cellNumber,
            workNumber: workNumber,
            employeeId: employeeId,
            createdBy: login.appUserId,
            updatedBy: login.appUserId,
            locationId: locationName,
            isApprovalUser: approvalUser,
            isContact: contactUser,
            appUserId: login.appUserId,
          })
        );
      } else if (editUser === false || addContact === true) {
       
          dispatch(
            addEployerUser(config.baseUrl, {
              employerUserId: 0,
              employerId: login.employerId,
              userType: userType,
              firstName: firstName,
              lastName: lastName,
              email: email,
              password: password,
              cellPhoneNumber: cellNumber,
              workNumber: workNumber,
              employeeId: employeeId,
              createdBy: login.appUserId,
              updatedBy: login.appUserId,
              locationId: locationName,
              isApprovalUser: approvalUser,
              isContact: contactUser,
              appUserId: login.appUserId,
            })
          );
      }
    }
  };

  const showResetModal = (row) => {
    dispatch(setInitialState());
    setShowReset(true);
  };

  function cancel() {
    if (editUser === true || editUser === false) {
      navigate('/user');
    } else {
      navigate('/contacts');
    }
  }

  const handleResetClose = () => setShowReset(false);

  const handlePasswordReset = () => {
    dispatch(forgotPassword(config.baseUrl, email));
  };

  /* const handleDelete = () => {
    dispatch(deleteLocation(config.baseUrl, deleteId, login.appUserId));
    setShowDelete(false);
} */
  return (
    <div>
      <div>
        <div>
          <div class="col-xl-14" id="userForm">
          <Form autoComplete="off" noValidate onSubmit={validateAndSubmit}>
              <Row>
                <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="locationName">
                  <Form.Label>Default Location<span class="required">*</span></Form.Label>
                  <Form.Control
                    as="select"
                    value={locationName}
                    onChange={(e) => {
                      setLocationName(e.currentTarget.value);
                    }}
                    isInvalid={!!errors.locationName}
                  >
                    <option value="">--Select--</option>
                    {locationDropdownList.map((area, n) => (
                      <option key={`traveldistance_${n}`} value={area.id}>
                        {area.name}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.locationName}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="employeeId">
                  <Form.Label>Employee ID</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Employee ID"
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.currentTarget.value);
                      validateEmpID('employeeId', e.currentTarget.value);
                    }}
                    isInvalid={!!errors.employeeId}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.employeeId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="firstName">
                  <Form.Label>First Name<span class="required">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.currentTarget.value);
                    }}
                    isInvalid={!!errors.firstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.firstName}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="lastName">
                  <Form.Label>Last Name<span class="required">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.currentTarget.value);
                    }}
                    isInvalid={!!errors.lastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.lastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                
                {!editUser && (
                  <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="password">
                    <Form.Label>Password<span class="required">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.currentTarget.value);
                      }}
                      isInvalid={!!errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
                {editUser && (
                  <Form.Group as={Col} className="form-group col-md-6 mb-0 resetButton">
                    <Button
                      class="btn btn-success my-1"
                      type="button"
                      onClick={showResetModal}
                    >
                      Reset Password
                    </Button>
                  </Form.Group>
                )}
                {!editUser && (
                  <Form.Group
                    as={Col}
                    className="mb-2"
                    controlId="confirmPassword"
                  >
                    <Form.Label>Confirm Password<span class="required">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.currentTarget.value);
                      }}
                      isInvalid={!!errors.confirmPassword}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.confirmPassword}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Row>
              <Row>
                <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="email">
                  <Form.Label>Email<span class="required">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.currentTarget.value);
                    }}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="cellNumber">
                  <Form.Label>Cell #<span class="required">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Cell Phone"
                    value={cellNumber}
                    onChange={(e) => {
                      validatePhoneNumber('cellNumber', e.currentTarget.value);
                    }}
                    isInvalid={!!errors.cellNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.cellNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
             
              <Row>
                <Form.Group
                  as={Col}
                  className="form-group col-md-6 mb-0 multiSelectContainer"
                  controlId="userType"
                >
                  <Form.Label>User Type<span class="required">*</span></Form.Label>
                  <Form.Control
                    as="select"
                    value={userType}
                    onChange={(e) => {
                      setUserType(e.currentTarget.value);
                      if (parseInt(e.currentTarget.value) === 3) {
                        setApprovalUser(false);
                      }
                      if (parseInt(e.currentTarget.value) === 3) {
                        setContactUser(false);
                      }
                    }}
                    isInvalid={!!errors.userType}
                  >
                    <option value="">--Select--</option>
                    {userTypesList.map((area, n) => (
                      <option key={`userType${n}`} value={area.id}>
                        {area.name}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.userType}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="workNumber">
                  <Form.Label>Work #<span class="required">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Work Phone"
                    value={workNumber}
                    onChange={(e) => {
                      validatePhoneNumber('workNumber', e.currentTarget.value);
                    }}
                    isInvalid={!!errors.workNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.workNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
             
              <Row>
              <Form.Group as={Col} className="my-auto col-md-3" controlId="checkApproval">
                  <Form.Label></Form.Label>
                  <Form.Check
                    type="checkbox"
                    label="Location Approval User"
                    checked={approvalUser}
                    onChange={(e) => {
                      setApprovalUser(e.currentTarget.checked);
                    }}
                    disabled={parseInt(userType) === 3}
                  />
                </Form.Group>
                <Form.Group as={Col} className="my-auto col-md-3" controlId="checkContact">
                  <Form.Label></Form.Label>
                  <Form.Check
                    type="checkbox"
                    label="Location Contact User"
                    checked={contactUser}
                    onChange={(e) => {
                      setContactUser(e.currentTarget.checked);
                    }}
                    disabled={parseInt(userType) === 3}
                  />
                </Form.Group>
               
              </Row>
              <div class="card-footer text-end formButton">
                <Button class="btn btn-success my-1" type="Submit" disabled={saveButtonDisabled}>
                  Save
                </Button>
                <button
                 
                  class="btn btn-outline-primary"
                  type="Submit"
                  onClick={cancel}
                  disabled={saveButtonDisabled}
                >
                  Cancel
                </button>
              </div>
            </Form>
          </div>

          <ResetModal
            showReset={showReset}
            handleResetClose={handleResetClose}
            handlePasswordReset={handlePasswordReset}
            email={email}
            resetSuccess={resetSuccess}
            resetError={resetError}
          />
        </div>
      </div>
    </div>
  );
};
